/** FIN-8011: ponto do AppRoot, logo abaixo do "Atendimento", onde entra a faixa do contador. */
export const OFFER_COUNTDOWN_BAR_SLOT_ID = 'offer-countdown-bar-slot';
